import React from 'react'
// libs
import { useDispatch, useSelector } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
// components
import { ReduxSelect } from 'components/FormElements'
// constants
import { Forms } from 'constants/forms'
import { FieldType } from 'types/graphql'
// store
import { responseTypesSelector } from 'store/reducers/riskTemplates'
import { objectEntitiesSelector } from 'store/reducers/objectEntities'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// views
import { SetFieldWrapper } from './views'
// utils
import { required } from 'utils/validators'
import { getFieldsList, getReviewFieldIds } from 'utils/fields'
import {
  getFieldNameOptions,
  getFieldValueField,
  getRTEntityOrFieldOptions,
  getRTFieldValueField
} from 'utils/systemProcess'

interface Props {
  field: string
}

const selector = formValueSelector(Forms.SYSTEM_PROCESS_CREATE_FORM)

const SetProperty: React.FC<Props> = ({ field }) => {
  const dispatch = useDispatch()

  const { isRiskTemplate, riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const object = useSelector((state) => selector(state, 'object'))
  const property = useSelector((state) => selector(state, `${field}.fieldName`))
  const objectEntities = useSelector(objectEntitiesSelector)
  const responseTypeSets = useSelector(responseTypesSelector)

  const onChange = () => dispatch(change(Forms.SYSTEM_PROCESS_CREATE_FORM, `${field}.fieldValue`, null))

  const entityFields = React.useMemo(() => {
    if (isRiskTemplate) {
      return getRTEntityOrFieldOptions({ riskTemplate, responseTypeSets, isTransaction: true }).filter((item) =>
        [FieldType.PickList, FieldType.Lookup, FieldType.Date].includes(item.fieldType)
      )
    }

    return object
      ? getFieldNameOptions(
          getFieldsList(objectEntities, object.label),
          getReviewFieldIds(objectEntities, object.label)
        )
      : []
  }, [isRiskTemplate, riskTemplate, object, objectEntities, responseTypeSets])

  return (
    <SetFieldWrapper>
      <ReduxSelect
        label='Property'
        validate={required}
        options={entityFields}
        menuPortalTarget={null}
        onSelectChange={onChange}
        name={`${field}.fieldName`}
      />
      {isRiskTemplate ? getRTFieldValueField(property, field) : getFieldValueField(property, field)}
    </SetFieldWrapper>
  )
}

export default SetProperty
